import React from "react";
import { Passengers } from "../OrderDetail/Passengers";

function VoidConfirmationPassengers({ data }) {
  return (
    <div className="w-full">
      <Passengers
        order={{ booking: { flightBooking: [data?.flightBooking] } }}
      />
    </div>
  );
}

export default VoidConfirmationPassengers;
